import { css } from 'styled-components';

const mediaCover = css`
    margin: auto;
    width: 100%;
    height: 100%;
    object-fit: cover;
`;

const svgBase = css`
    width: 100%;
    height: 100%;
    overflow: visible;
    fill: currentColor;
`;

const iconWrapper = css`
    display: grid;
    place-items: center;
    flex: 0 0 auto;

    svg {
        ${svgBase}
    }
`;

export const styledMedia = {
    mediaCover,
    svgBase,
    iconWrapper,
};

export const iconSize = {
    smallest: 6,
    smaller: 12,
    small: 16,
    medium: 18,
    default: 20,
};
